import { AlertText } from './styled/ShareList.styled';

const PublicLinkAlert = () => (
  <>
    <div>
      <AlertText>
        <b>
          Atenção 1:
        </b>
        {' '}
        Alterações realizadas no dashboard não são atualizadas automaticamente no
        link público. Para que as alterações tenham efeito, é necessário que o link
        seja atualizado manualmente.
      </AlertText>
    </div>
    <div>
      <AlertText>
        <b>
          Atenção 2:
        </b>
        {' '}
        Caso o seu dashboard possua subtabelas, gráficos com subgráficos ou filtros globais, as
        subtabelas não podem ser renderizadas, os subgráficos não podem ser acessados e
        filtros globais não podem ser aplicados no link público.
      </AlertText>
    </div>
    <div style={{ textAlign: 'center' }}>
      <AlertText>
        <b>
          O dashboard público é uma cópia estática do dashboard original.
        </b>
      </AlertText>
    </div>
  </>
);

export default PublicLinkAlert;
